import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { AuthService } from '../services/auth/auth.service';
import { AppRoute } from '../../routing/routing.config';

@Injectable({
  providedIn: 'root',
})
export class WelcomeGuard {
  constructor(
    private logger: NGXLogger,
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkAccess(route);
  }

  private async checkAccess(route: ActivatedRouteSnapshot): Promise<boolean> {
    this.logger.info('[WelcomeGuard] checkAccess - route: ', route);

    if(await this.authService.isAuthenticated()) {
      this.logger.info('[WelcomeGuard] User is authenticated - redirect to App Login.');
      this.router.navigate([AppRoute.APP_LOGIN]);

      return false;
    }

    return true;
  }
}
